import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
var rc = function () {
  var _a;
  return (_a = window.__RUNTIME_CONFIG__) !== null && _a !== void 0 ? _a : {};
};
var rumInitialized = false;
var LOCAL_HOSTNAMES = /^(localhost|127\.0\.0\.1|\[::1\]|::1|0\.0\.0\.0)$/;
function shouldSkipLocalSession(config) {
  var _a;
  var forced = ((_a = config.DD_FORCE_RUM) !== null && _a !== void 0 ? _a : process.env.REACT_APP_DD_FORCE_RUM) === 'true';
  return !forced && LOCAL_HOSTNAMES.test(window.location.hostname);
}
export function setupDatadogRum() {
  var _a, _b, _c, _d, _e;
  if (rumInitialized || ((_a = datadogRum.getInitConfiguration) === null || _a === void 0 ? void 0 : _a.call(datadogRum))) {
    return;
  }
  var config = rc();
  if (shouldSkipLocalSession(config)) {
    return;
  }
  datadogRum.init({
    applicationId: config.DD_RUM_APPLICATION_ID || process.env.REACT_APP_DD_RUM_APPLICATION_ID || '',
    clientToken: config.DD_RUM_CLIENT_TOKEN || process.env.REACT_APP_DD_RUM_CLIENT_TOKEN || '',
    site: config.DD_SITE || process.env.REACT_APP_DD_SITE || '',
    service: config.DD_SERVICE || process.env.REACT_APP_DD_SERVICE || '',
    env: config.DD_ENV || process.env.REACT_APP_DD_ENV || '',
    version: process.env.REACT_APP_VERSION || '',
    sessionSampleRate: Number((_c = (_b = config.DD_SESSION_SAMPLE_RATE) !== null && _b !== void 0 ? _b : process.env.REACT_APP_DD_SESSION_SAMPLE_RATE) !== null && _c !== void 0 ? _c : 100),
    sessionReplaySampleRate: Number((_e = (_d = config.DD_SESSION_REPLAY_SAMPLE_RATE) !== null && _d !== void 0 ? _d : process.env.REACT_APP_DD_SESSION_REPLAY_SAMPLE_RATE) !== null && _e !== void 0 ? _e : 20),
    allowedTracingUrls: [window.location.origin],
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    // Automatic view tracking — router: true sets trackViewsManually and can leave RUM stuck
    // in pre-start (getInternalContext always undefined) if startView races init/session setup.
    plugins: [reactPlugin()]
  });
  rumInitialized = true;
}
/** @internal Reset for tests only */
export function resetDatadogRumForTests() {
  rumInitialized = false;
}